module.exports = __webpack_public_path__ + "img/pef_investment_overview_icon02.dc5adf41.svg";